import { Component } from '@angular/core';

@Component({
  selector: 'zc-card-footer',
  templateUrl: './card-footer.component.html',
  styleUrls: ['./card-footer.component.scss'],
})
export class CardFooterComponent {}
